import React, {useState} from "react";
import {selfcareCreatePassword} from "../../util/request";
import {useNavigate, useSearchParams} from "react-router-dom";
import SelfcarePageContent from "../../components/selfcare/SelfcarePageContent";
import useLoginCheck from "../../util/useLoginCheck";
import Routing from "../../Routing.ts";
import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";

export default function CreatePasswordPage() {
    setTitleAndMetaDescription("Nulstil - Mit Hiper", "Her kan du nulstille din adgangskode eller oprette en ny bruger til Mit Hiper ved at indtaste din email.");

    const navigate = useNavigate()
    const [searchParams] = useSearchParams()

    const [passwordOne, setPasswordOne] = useState<string>("")
    const [passwordTwo, setPasswordTwo] = useState<string>("")
    const [rememberMe, setRememberMe] = useState<boolean>(true)

    const [loading, setLoading] = useState<boolean>(false)
    const [errorMessage, setErrorMessage] = useState<string | null>(null)
    const [successMessage, setSuccessMessage] = useState<string | null>(null)
    const [finished, setFinished] = useState<boolean>(false)

    useLoginCheck()

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (passwordOne !== passwordTwo) {
            setErrorMessage("De to adgangskoder er ikke ens");
            return
        }

        setLoading(true)

        selfcareCreatePassword(passwordOne, passwordTwo, searchParams.get('hash') ?? '', rememberMe)
            .then(r => {
                if (r.code !== 201) {
                    setErrorMessage(r.response.error_message as string)
                    return
                }
                setSuccessMessage("")
                navigate(Routing.Selfcare.Login, {state: 'created'})
                setFinished(true)
            })
            .catch(() => setErrorMessage("Noget gik galt. Prøv igen"))
            .finally(() => setLoading(false))
    }

    return <SelfcarePageContent title={"Få adgang til Mit Hiper"} className={`selfcare-page-login`}>

        {(errorMessage || successMessage) && <section className="selfcare-messages">
            {errorMessage !== null &&
                <div className="selfcare-message-error show">
                    <p>{errorMessage}</p>
                </div>
            }
            {successMessage !== null &&
                <div className="selfcare-message-success show">
                    <p>{successMessage}</p>
                </div>
            }
        </section>}

        <div className="selfcare-page-summary">
            <p>Indtast din nye valgte kode to gange nedenunder.</p>
        </div>
        <form
            onSubmit={handleSubmit}
            className="selfcare-login-resend selfcare-menu__slide"
            method="post"
            id="selfcare-create-input"
            noValidate
            rel="nofollow"
        >
            <p>
                <input
                    type="password"
                    name="password-one"
                    disabled={loading || finished}
                    value={passwordOne}
                    onChange={(e) => setPasswordOne(e.target.value)}
                    placeholder="Adgangskode"
                    autoComplete={"new-password"}
                    required
                />
            </p>
            <p>
                <input
                    type="password"
                    name="password-two"
                    disabled={loading || finished}
                    value={passwordTwo}
                    onChange={(e) => setPasswordTwo(e.target.value)}
                    placeholder="Gentag adgangskode"
                    autoComplete={"new-password"}
                    required
                />
                <span className="input-help-text">
                    Din kode skal være mindst 8 tegn lang, indeholde mindst et stort og et lille bogstav, og et tal.
                </span>
            </p>
            <p className="with-checkbox">
                <input type="checkbox" id="selface-login__remember_me" name="remember_me" defaultChecked={rememberMe} onClick={() => setRememberMe(!rememberMe)}/>
                <label className="checkbox-label checkbox-label--montserrat" htmlFor="selface-login__remember_me">
                    Husk mig
                </label>
            </p>
            <p className="submit-button-block">
                <label id="submit-form-button" className="button teal">
                    <input className="continue-button-submit" type="submit"/>
                    <span className="text">Opret &amp; Log ind</span>
                </label>
            </p>
        </form>
    </SelfcarePageContent>
}
